import { render } from "./TokenSearch.vue?vue&type=template&id=dc6d0134&scoped=true"
import script from "./TokenSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./TokenSearch.vue?vue&type=script&setup=true&lang=js"

import "./TokenSearch.vue?vue&type=style&index=0&id=dc6d0134&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc6d0134"],['__file',"resources/js/components/TokenSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dc6d0134"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dc6d0134', __exports__)) {
    api.reload('dc6d0134', __exports__)
  }
  
  module.hot.accept("./TokenSearch.vue?vue&type=template&id=dc6d0134&scoped=true", () => {
    api.rerender('dc6d0134', render)
  })

}


export default __exports__